module.exports = __webpack_public_path__ + "img/integralBG1.ff32e684.png";